import { availablePhoneNumbersQueryVariables, useavailablePhoneNumbersLazyQuery } from '@/types/generated/graphql';
import { NetworkStatus } from '@apollo/client';
import { useCallback, useEffect } from 'react';
import { removeFalsyValues } from '../utils/utility';

export const useAvailableNumberSearch = (variables: availablePhoneNumbersQueryVariables) => {
  const [getNumber, { data, loading, refetch, networkStatus }] = useavailablePhoneNumbersLazyQuery({
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const availableNumbers =
    data?.availablePhoneNumbers?.edges?.map((edge) => {
      return {
        id: edge?.phoneNumber,
        addressRequirements: edge?.addressRequirements,
        number: edge?.phoneNumber,
        capabilities: edge?.capabilities,
        numberType: edge?.numberType,
        monthlyFee: edge?.basePrice,
        row: edge,
      };
    }) ?? [];

  const isRefetching = networkStatus === NetworkStatus.refetch;

  const fetchNumbers = useCallback(() => {
    if (!variables) return;
    const cleanVariables = removeFalsyValues(variables);
    getNumber({ variables: cleanVariables });
  }, [JSON.stringify(variables)]);

  useEffect(() => {
    fetchNumbers();
  }, [fetchNumbers]);

  return {
    getNumber,
    phoneNumbers: availableNumbers,
    loading: loading,
    isRefetching,
    refetch,
  };
};
